//@author: devin

import { jSith } from "./jquery-replacement";
import { S25Const } from "./s25-const";
import { S25WsNode } from "../pojo/S25WsNode";
import { S25String } from "./core/s25.string";
import { S25Number } from "./core/s25.number";
import { S25Bool } from "./core/s25.bool";
import { S25Bootstrap } from "./core/s25.bootstrap";
import { S25DirectiveUtil } from "./core/s25.directive.util";
import { S25Color } from "./core/s25.color";
import { S25Jquery } from "./core/s25.jquery";
import { S25Xml } from "./core/s25.xml";
import { S25Json } from "./core/s25.json";
import { S25Async } from "./core/s25.async";
import { S25Promise } from "./core/s25.promise";
import { S25Browser } from "./core/s25.browser";
import { S25Fetch } from "./core/s25.fetch";
import { S25LocalStorage } from "./core/s25.local.storage";
import { S25Cookie } from "./core/s25.cookie";
import { S25Url } from "./core/s25.url";
import { S25UUID } from "./core/s25.uuid";
import { S25Date } from "./core/s25.date";
import { S25DateParse } from "./core/s25.date.parse";
import { S25Duration } from "./core/s25.duration";
import { S25ObjectUtil } from "./core/s25.object.util";
import { S25Object } from "./core/s25.object";
import { S25ArraySort } from "./core/s25.array.sort";
import { S25Array } from "./core/s25.array";
import { S25Error } from "./core/s25.error";
import { isArray, isDate, isDefined, isFunction, isObject, isString, isUndefined } from "./core";
import { S25Timezone } from "./core/s25.timezone";
import { S25Address } from "./core/s25.address";
import { S25Event } from "../modules/s25-event/EventMicroI";
import { S25AngJs } from "./core/s25.angjs";
import { Item } from "../pojo/Item";
import { S25ReactiveForms } from "./core/s25.reactive.forms";
import { S25Map } from "./core/s25.map";

/** @deprecated Use properties from individual utils instead */
export const S25Util = {
    xml: S25Xml,
    json: S25Json,
    bool: S25Bool,
    jquery: S25Jquery,
    bootstrap: S25Bootstrap,
    directive: S25DirectiveUtil,
    reactiveForms: S25ReactiveForms,
    date: {
        ...S25Date,
        parse: S25DateParse,
        parseDate: S25DateParse.date,
        parseTime: S25DateParse.time,
        clone: S25DateParse.clone,
        addPuncToDateTimeStr: S25DateParse.addPuncToDateTimeStr,
        parseDropTZ: S25DateParse.parseDropTZ,
        parseFuzzyTimeString: S25DateParse.parseFuzzyTimeString,
        isDate,
        timezone: S25Timezone,
        minutesToTime: S25Duration.minutesToTime,
    },
    array: {
        ...S25Array,
        isArray,
        propertyListToArray: S25Object.propertyListToArray,
    },

    ...S25AngJs,
    ...S25Async,
    ...S25Bool,
    ...S25Browser,
    /* S25Browser.isInIframe is mutable, so override it with a getter */
    get isInIframe(): boolean {
        return S25Browser.isInIframe;
    },

    ...S25Color,
    ...S25Duration,
    ...S25Fetch,
    ...S25Json,
    ...S25Number,
    ...S25ObjectUtil,
    ...S25String,
    ...S25Promise,
    ...S25Url,
    ...S25Xml,
    ...S25Map,

    isUndefined,
    isDefined,
    isObject,
    isFunction,
    isString,

    shallowSort: S25ArraySort.shallow,
    stableSort: S25ArraySort.stable,
    sortMultiProps: S25ArraySort.multiProps,
    sortNumeric: S25ArraySort.numeric,
    shallowSortMultProps: S25ArraySort.shallowMultProps,
    shallowSortDates: S25ArraySort.shallowDates,
    sortAlphaNum: S25ArraySort.alphaNum,

    isStatusChanged: S25WsNode.isStatusChanged,
    profileName: Item.profileName,
    isPrivate: Item.isPrivate,
    completeEventLocator: S25Event.getLocator,
    isPartialEventLocator: S25Event.isPartialLocator,
    isEventLocator: S25Event.isLocator,
    extractAddress: S25Address.extract,
    addressObjToNode: S25Address.toNode,
    errorText: S25Error.extract,
    errorTextAll: S25Error.extractAll,
    showError: S25Error.show,
    setCookie: S25Cookie.set,
    getCookie: S25Cookie.get,
    deleteCookie: S25Cookie.remove,
    randomUUID: S25UUID.random,
    generateQuickGUID: S25UUID.quickGUID,
    localStorageGet: S25LocalStorage.get,
    localStorageSet: S25LocalStorage.set,
    localStorageRemove: S25LocalStorage.remove,
    localStorageClear: S25LocalStorage.clear,
    instanceId: S25Const.instanceId,
    instanceIdWithPrefix: S25Const.instanceIdWithPrefix,
    extend: S25Object.extend,
    fromEntries: S25Object.fromEntries,
    clearObject: S25Object.clear,
    reverseObject: S25Object.reverse,
    objectKeys: S25Object.keys,
    entries: S25Object.entries,
    values: S25Object.values,
    safeValues: S25Object.safeValues,
    toItemIds: S25Array.toItemIds,
    findBoundaries: S25Array.findBoundaries,
    isInBoundary: S25Array.isInBoundary,
    range: S25Array.range,
    toStr: jSith.toStr,
    coalesce: jSith.coalesce,

    // TODO: move skipLoginInterval to LoginService or something
    skipLoginInterval: false,
};

export type DebounceTsOptions = S25Async.DebounceTsOptions;
export type DebouncedOptions<F extends (...args: unknown[]) => unknown> = S25Async.DebouncedOptions<F>;
